import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "./api";
import { resetOpsCache } from "./stubs";
import type { Me } from "./types";

/** The signed-in admin user, or null when signed out. */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<Me | null> => {
      try {
        const r = await api<{ user: Me }>("/api/v1/auth/me");
        return r.user;
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) {
          resetOpsCache(); // signed out: the operation list is asked for again after the next sign-in
          return null;
        }
        throw e;
      }
    },
    staleTime: 60_000,
  });
}

/** Admin-only actions (tokens, CRM settings, custom fields, users) need the admin role; staff get 403. */
export function useIsAdmin(): boolean {
  return useMe().data?.role === "admin";
}
